import { Button, Flex } from '@elkaso-app/web-design';
import { ReconciliationStatusCounts, ReconciliationStatusFilter } from 'apis/reconciliation';
import { usePageParams } from 'hooks/use-page-params';

interface ITab {
  value: ReconciliationStatusFilter;
  label: string;
  count?: number;
}

interface IStatusTabs {
  statusCounts?: ReconciliationStatusCounts;
}

// Counts come from the list response's statusCounts block, which ignores the
// active status filter itself — so they stay stable no matter which tab is active.
export const StatusTabs = ({ statusCounts }: IStatusTabs) => {
  const { getPageParams, setPageParams } = usePageParams();
  const params = getPageParams();
  const active = (params.status as string) || 'all';

  const tabs: ITab[] = [
    { value: 'all', label: 'All', count: statusCounts?.all },
    { value: 'discrepancies', label: 'Discrepancies', count: statusCounts?.discrepancies },
    { value: 'open', label: 'Open', count: statusCounts?.open },
    { value: 'partially_collected', label: 'Partially collected', count: statusCounts?.partiallyCollected },
    { value: 'collected', label: 'Fully collected', count: statusCounts?.collected },
    { value: 'closed', label: 'Closed', count: statusCounts?.closed },
  ];

  const onSelect = (value: ReconciliationStatusFilter) => {
    const next = { ...params };
    delete next.page;
    if (value === 'all') delete next.status;
    else next.status = value;
    setPageParams(next);
  };

  return (
    // A wrapping Flex instead of ButtonGroup — the 6 pills exceed a phone's width, and
    // ButtonGroup renders a non-wrapping row. On desktop they still fit one line unchanged.
    <Flex wrap='wrap' gap='6px'>
      {tabs.map((tab) => {
        const isActive = active === tab.value;
        return (
          <Button
            key={tab.value}
            variant='outline'
            size='sm'
            onClick={() => onSelect(tab.value)}
            bg={isActive ? '#E03E52' : 'white'}
            color={isActive ? 'white' : 'gray.600'}
            border='1px solid'
            borderColor={isActive ? '#E03E52' : 'gray.200'}
            _hover={{ bg: isActive ? '#c93648' : 'gray.50' }}
            borderRadius='full'
            fontWeight='semibold'>
            {tab.label}
            {tab.count !== undefined && ` ${tab.count}`}
          </Button>
        );
      })}
    </Flex>
  );
};
